// extracted by mini-css-extract-plugin
export default {"page-netto":"netto_page-netto__0LeXN","title":"netto_title__Xd-ha","positive":"netto_positive__QZ4VV","negative":"netto_negative__d5GLd","total":"netto_total__txNGZ"};